import axios from 'axios';
import { BACKEND_URL } from '../apiConfig';

/**
 * Instância centralizada do Axios com interceptor para renovação automática de sessão (Token Refresh).
 */
const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

// Interceptor de resposta para lidar com expiração de token (401) e atualizar notificações
api.interceptors.response.use(
  (response) => {
    // Dispara um evento global se houver uma mutação (POST, PUT, PATCH, DELETE)
    // para atualizar a central de notificações imediatamente
    const method = response.config.method?.toLowerCase() || '';
    if (
      ['post', 'put', 'patch', 'delete'].includes(method) &&
      !response.config.url?.includes('/notifications')
    ) {
      window.dispatchEvent(new Event('triggerNotificationFetch'));
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Assinatura da clínica pendente/atrasada — o backend bloqueia o request
    // (ver security/auth.py) e manda o link de pagamento nos headers.
    if (error.response?.status === 402) {
      window.dispatchEvent(new CustomEvent('subscriptionBlocked', {
        detail: {
          status: error.response.headers['x-subscription-status'] || 'pending',
          checkoutUrl: error.response.headers['x-checkout-url'] || null,
        },
      }));
    }

    // Se o erro for 401 e ainda não tentamos o retry
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes('/auth/login/') &&
      !originalRequest.url?.includes('/auth/refresh/')
    ) {
      originalRequest._retry = true;

      try {
        await axios.post(`${BACKEND_URL}/api/auth/refresh/`, {}, { withCredentials: true });
        
        // Re-executa a requisição original com os novos cookies
        return api(originalRequest);
      } catch (refreshError) {
        // Limpa qualquer estado local se necessário e manda para o login
        console.error("ERRO: Falha ao renovar token ou sess\u00e3o expirada. Redirecionando para /login", refreshError);
        const publicPaths = ['/login', '/forgot-password', '/reset-password', '/publico', '/cadastro', '/verificar-email'];
        const isPublicPage = publicPaths.some(p => window.location.pathname.startsWith(p));
        if (!isPublicPage) {
            window.location.href = '/login';
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
